import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	nameColumnHeader: {
		id: 'users-and-roles.actors-table.name-column-header',
		description: 'Header title for name column',
		defaultMessage: 'Name',
	},
	emailColumnHeader: {
		id: 'users-and-roles.actors-table.email-column-header',
		description: 'Header title for email column',
		defaultMessage: 'Email',
	},
	roleColumnHeader: {
		id: 'users-and-roles.actors-table.role-column-header',
		description: 'Header title for role column',
		defaultMessage: 'Role',
	},
	removeColumnHeader: {
		id: 'users-and-roles.actors-table.remove-column-header',
		description: 'Header title for remove column',
		defaultMessage: 'Action',
	},
	remove: {
		id: 'users-and-roles.actors-table.remove',
		description: 'Remove actor button text',
		defaultMessage: 'Remove',
	},
	paginationPrev: {
		id: 'users-and-roles.actors-table.pagination-prev',
		defaultMessage: 'Prev',
		description: 'Text for going to the previous page in the actors table',
	},
	paginationNext: {
		id: 'users-and-roles.actors-table.pagination-next',
		defaultMessage: 'Next',
		description: 'Text for going to the next page in the actors table',
	},
	tableAriaLabel: {
		id: 'users-and-roles.actors-table.table-aria-label',
		defaultMessage: 'People and their roles',
		description: 'Message to be announced to users who use the screen readers',
	},
});
